import _forEach from 'lodash/forEach'
import { Bot } from 'app/api/BotAPI'
import BotConstants from 'constants/BotConstants'

class BotStore extends Marty.Store {
  state = false
  handlers = {
    botFetched: BotConstants.FETCH_BOT_FINISHED,
    updateBotEnabled: BotConstants.ENABLE_BOT_FINISHED,
    updateBot: BotConstants.UPDATE_BOT_FINISHED,
    updateBotAvatar: BotConstants.UPLOAD_BOT_AVATAR_FINISHED,
  }

  dehydrate() {
    if (!this.state) {
      return this.state
    }
    return this.state.toJS()
  }

  rehydrate(dehydratedState) {
    if (!!dehydratedState) {
      return Bot({...dehydratedState})
    }
    return dehydratedState
  }

  getBot() {
    return this.fetch({
      id: 'getBot',
      dependsOn: [this.app.stores.OrgStore.getOrFetchCurrentOrg()],
      locally() {
        if (!!this.state) {
          return this.state
        }
      },
      remotely() {
        const orgId = this.app.stores.OrgStore.getCurrentOrg().id
        return this.app.actions.BotActions.fetchBot(orgId)
      }
    })
  }

  botFetched(bot) {
    this.state = bot
  }

  updateBotEnabled(enabled) {
    this.state = this.state.set("enabled", enabled)
  }

  updateBot(properties) {
    this.state = this.state.withMutations(state => {
      _forEach(properties, (value, key) => state.set(key, value))
    })
  }

  updateBotAvatar(file) {
    this.state = this.state.set("avatarUrl", file.preview)
  }
}

export default BotStore



// WEBPACK FOOTER //
// ./src/scripts/stores/BotStore.js